import { pageLanguage, type Language } from '@bn-games/i18n-core';
import type { ThemeName } from '@bn-games/theming';
import type { Difficulty } from '../game/types.js';

export type { Difficulty, Language, ThemeName };

/**
 * Sudoku settings. The base `@bn-games/settings-core` SettingsManager is
 * generic over `TSettings extends object`; the canonical `theme` + `language`
 * fields live here alongside the sudoku-specific knobs.
 */
export interface Settings {
  readonly difficulty: Difficulty;
  readonly highlightErrors: boolean;
  readonly theme: ThemeName;
  readonly language: Language;
}

export const DEFAULT_SETTINGS: Settings = {
  difficulty: 'medium',
  highlightErrors: true,
  theme: 'mahogany',
  // A /…/ru/ page opens in Russian unless the player already chose a language.
  language: pageLanguage(),
};
